import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'array_of_numbers' })
export class ArrayOfNumbersPipe implements PipeTransform {
    transform(end: number, start: number = 0): any[] {
        let arr = [];
        for (let i = start; i <= end; i++)arr.push(i);
        return arr;
    }
}